// Teacher <-> parent messaging page.
const en = {
  sidebar: {
    links: { messages: "Messages" },
    collapse: "Collapse the menu",
    expand: "Expand the menu",
  },
  messages: {
    title: "Messages",
    subtitleParent: "Talk with your children's teachers.",
    subtitleTeacher: "Talk with your students' parents.",
    subtitleStaff: "All teacher–parent conversations (read only).",
    newConversation: "New conversation",
    searchPlaceholder: "Search a name…",
    empty: "No conversations yet.",
    emptyHintParent: "Start one with a teacher of your child.",
    emptyHintTeacher: "Start one with a parent of your students.",
    pickTitle: "Who do you want to write to?",
    noContactsParent:
      "Your child has no teacher yet. Once a lesson or a class is set up, you can write to the teacher here.",
    noContactsTeacher:
      "You have no students yet. Once a lesson or a class is set up, you can write to their parents here.",
    aboutChild: "About {{name}}",
    roleTeacher: "Teacher",
    roleParent: "Parent",
    selectConversation: "Choose a conversation to read the messages.",
    noMessages: "No messages yet. Say hello!",
    placeholder: "Write a message…",
    send: "Send",
    attach: "Attach a file",
    removeFile: "Remove the file",
    fileTooBig: "Files over 10 MB were left out.",
    sendError: "The message could not be sent. Try again.",
    loadError: "Messages could not be loaded.",
    readOnly: "You can read this conversation but not write in it.",
    you: "You",
    today: "Today",
    yesterday: "Yesterday",
    back: "Conversations",
    enterHint: "Enter to send · Shift+Enter for a new line",
    seen: "Seen",
    typing: "is typing…",
    reply: "Reply",
    edit: "Edit",
    delete: "Delete",
    copy: "Copy",
    copied: "Copied!",
    more: "More",
    react: "React",
    edited: "edited",
    deletedMessage: "Message deleted",
    deleteConfirm: "Delete this message for everyone?",
    attachment: "Attachment",
    replyingTo: "Replying to {{name}}",
    yourself: "yourself",
    editing: "Editing your message",
    saveEdit: "Save",
    sending: "Sending…",
    failedRetry: "Not sent — tap to retry",
    online: "Online",
    activeNow: "Active just now",
    activeMinutes: "Active {{count}} min ago",
    lastSeen: "Last seen {{when}}",
    newMessages: "New messages",
    jumpToLatest: "Latest messages",
    newBelow: "{{count}} new",
    emoji: "Emoji",
    emojiRecent: "Recent",
    emojiSmileys: "Smileys",
    emojiGestures: "Gestures",
    emojiHearts: "Hearts & symbols",
    emojiSchool: "School",
    emojiNature: "Animals & nature",
    emojiFood: "Food",
    recordVoice: "Record a voice message",
    recording: "Recording…",
    voiceMessage: "Voice message",
    micDenied: "The microphone can't be used. Allow it in your browser settings.",
    dropHere: "Drop the file to send it",
    tooManyFiles: "You can send up to {{count}} files at once.",
    filesToSend: "Files to send",
    addFiles: "Add files",
    openFull: "Open in full page",
    close: "Close",
    openChat: "Open messages",
    cancel: "Cancel",
  },
};

const fr = {
  sidebar: {
    links: { messages: "Messages" },
    collapse: "Réduire le menu",
    expand: "Agrandir le menu",
  },
  messages: {
    title: "Messages",
    subtitleParent: "Échangez avec les enseignants de vos enfants.",
    subtitleTeacher: "Échangez avec les parents de vos élèves.",
    subtitleStaff: "Toutes les conversations enseignants–parents (lecture seule).",
    newConversation: "Nouvelle conversation",
    searchPlaceholder: "Rechercher un nom…",
    empty: "Aucune conversation pour le moment.",
    emptyHintParent: "Commencez-en une avec un enseignant de votre enfant.",
    emptyHintTeacher: "Commencez-en une avec un parent de vos élèves.",
    pickTitle: "À qui voulez-vous écrire ?",
    noContactsParent:
      "Votre enfant n'a pas encore d'enseignant. Dès qu'un cours ou une classe est prévu, vous pourrez écrire à l'enseignant ici.",
    noContactsTeacher:
      "Vous n'avez pas encore d'élèves. Dès qu'un cours ou une classe est prévu, vous pourrez écrire à leurs parents ici.",
    aboutChild: "Au sujet de {{name}}",
    roleTeacher: "Enseignant",
    roleParent: "Parent",
    selectConversation: "Choisissez une conversation pour lire les messages.",
    noMessages: "Aucun message pour l'instant. Dites bonjour !",
    placeholder: "Écrivez un message…",
    send: "Envoyer",
    attach: "Joindre un fichier",
    removeFile: "Retirer le fichier",
    fileTooBig: "Les fichiers de plus de 10 Mo n'ont pas été ajoutés.",
    sendError: "Le message n'a pas pu être envoyé. Réessayez.",
    loadError: "Impossible de charger les messages.",
    readOnly: "Vous pouvez lire cette conversation mais pas y écrire.",
    you: "Vous",
    today: "Aujourd'hui",
    yesterday: "Hier",
    back: "Conversations",
    enterHint: "Entrée pour envoyer · Maj+Entrée pour aller à la ligne",
    seen: "Vu",
    typing: "est en train d'écrire…",
    reply: "Répondre",
    edit: "Modifier",
    delete: "Supprimer",
    copy: "Copier",
    copied: "Copié !",
    more: "Plus",
    react: "Réagir",
    edited: "modifié",
    deletedMessage: "Message supprimé",
    deleteConfirm: "Supprimer ce message pour tout le monde ?",
    attachment: "Pièce jointe",
    replyingTo: "Réponse à {{name}}",
    yourself: "vous-même",
    editing: "Modification du message",
    saveEdit: "Enregistrer",
    sending: "Envoi…",
    failedRetry: "Non envoyé — toucher pour réessayer",
    online: "En ligne",
    activeNow: "Actif à l'instant",
    activeMinutes: "Actif il y a {{count}} min",
    lastSeen: "Vu {{when}}",
    newMessages: "Nouveaux messages",
    jumpToLatest: "Derniers messages",
    newBelow: "{{count}} nouveau(x)",
    emoji: "Émojis",
    emojiRecent: "Récents",
    emojiSmileys: "Smileys",
    emojiGestures: "Gestes",
    emojiHearts: "Cœurs & symboles",
    emojiSchool: "École",
    emojiNature: "Animaux & nature",
    emojiFood: "Nourriture",
    recordVoice: "Enregistrer un message vocal",
    recording: "Enregistrement…",
    voiceMessage: "Message vocal",
    micDenied: "Le micro n'est pas accessible. Autorisez-le dans les réglages du navigateur.",
    dropHere: "Déposez le fichier pour l'envoyer",
    tooManyFiles: "Vous pouvez envoyer {{count}} fichiers maximum à la fois.",
    filesToSend: "Fichiers à envoyer",
    addFiles: "Ajouter des fichiers",
    openFull: "Ouvrir en pleine page",
    close: "Fermer",
    openChat: "Ouvrir les messages",
    cancel: "Annuler",
  },
};

const ar = {
  sidebar: {
    links: { messages: "الرسائل" },
    collapse: "تصغير القائمة",
    expand: "توسيع القائمة",
  },
  messages: {
    title: "الرسائل",
    subtitleParent: "تواصل مع معلّمي أبنائك.",
    subtitleTeacher: "تواصل مع أولياء أمور تلاميذك.",
    subtitleStaff: "كل المحادثات بين المعلّمين والأولياء (قراءة فقط).",
    newConversation: "محادثة جديدة",
    searchPlaceholder: "ابحث عن اسم…",
    empty: "لا توجد محادثات بعد.",
    emptyHintParent: "ابدأ محادثة مع أحد معلّمي طفلك.",
    emptyHintTeacher: "ابدأ محادثة مع وليّ أمر أحد تلاميذك.",
    pickTitle: "لمن تريد أن تكتب؟",
    noContactsParent:
      "ليس لطفلك معلّم بعد. عندما تتم برمجة حصة أو قسم، يمكنك مراسلة المعلّم من هنا.",
    noContactsTeacher:
      "ليس لديك تلاميذ بعد. عندما تتم برمجة حصة أو قسم، يمكنك مراسلة أوليائهم من هنا.",
    aboutChild: "بخصوص {{name}}",
    roleTeacher: "معلّم",
    roleParent: "وليّ أمر",
    selectConversation: "اختر محادثة لقراءة الرسائل.",
    noMessages: "لا توجد رسائل بعد. ابدأ بالتحية!",
    placeholder: "اكتب رسالة…",
    send: "إرسال",
    attach: "إرفاق ملف",
    removeFile: "إزالة الملف",
    fileTooBig: "حجم الملف يتجاوز 10 ميغابايت.",
    sendError: "تعذّر إرسال الرسالة. حاول مرة أخرى.",
    loadError: "تعذّر تحميل الرسائل.",
    readOnly: "يمكنك قراءة هذه المحادثة دون الكتابة فيها.",
    you: "أنت",
    today: "اليوم",
    yesterday: "أمس",
    back: "المحادثات",
    enterHint: "Enter للإرسال · Shift+Enter لسطر جديد",
    seen: "تمت المشاهدة",
    typing: "يكتب الآن…",
    reply: "رد",
    edit: "تعديل",
    delete: "حذف",
    copy: "نسخ",
    copied: "تم النسخ!",
    more: "المزيد",
    react: "تفاعل",
    edited: "معدّلة",
    deletedMessage: "تم حذف الرسالة",
    deleteConfirm: "حذف هذه الرسالة للجميع؟",
    attachment: "مرفق",
    replyingTo: "رد على {{name}}",
    yourself: "نفسك",
    editing: "تعديل الرسالة",
    saveEdit: "حفظ",
    sending: "جارٍ الإرسال…",
    failedRetry: "لم تُرسل — اضغط لإعادة المحاولة",
    online: "متصل الآن",
    activeNow: "نشط منذ لحظات",
    activeMinutes: "نشط منذ {{count}} دقيقة",
    lastSeen: "آخر ظهور {{when}}",
    newMessages: "رسائل جديدة",
    jumpToLatest: "آخر الرسائل",
    newBelow: "{{count}} جديدة",
    emoji: "رموز تعبيرية",
    emojiRecent: "الأخيرة",
    emojiSmileys: "وجوه",
    emojiGestures: "إيماءات",
    emojiHearts: "قلوب ورموز",
    emojiSchool: "المدرسة",
    emojiNature: "حيوانات وطبيعة",
    emojiFood: "طعام",
    recordVoice: "تسجيل رسالة صوتية",
    recording: "جارٍ التسجيل…",
    voiceMessage: "رسالة صوتية",
    micDenied: "لا يمكن استخدام الميكروفون. اسمح به من إعدادات المتصفح.",
    dropHere: "أفلت الملف لإرساله",
    tooManyFiles: "يمكنك إرسال {{count}} ملفات كحد أقصى في المرة الواحدة.",
    filesToSend: "الملفات المراد إرسالها",
    addFiles: "إضافة ملفات",
    openFull: "فتح في صفحة كاملة",
    close: "إغلاق",
    openChat: "فتح الرسائل",
    cancel: "إلغاء",
  },
};

const messagesTranslations = { en, fr, ar };

export default messagesTranslations;
